import { OfferStatus } from "@/models/offerStatus";
import { Pagination } from "@/models/pagination";
import { IOfferStatus, OfferStatusState } from "@/types/offerStatus";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<OfferStatusState, IOfferStatus> = {
  single: (state, single) => {
    state.single = new OfferStatus(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new OfferStatus(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new OfferStatus();
    state.pagination = new Pagination();
  },
};

export default mutations;
